import { func, string } from 'prop-types';
import React, { Component } from 'react';

import { boolOptions } from '../../campaigns/constants';
import SingleSelect from '../SingleSelect';

const options = [...boolOptions, { label: 'All', value: '' }];

class BoolFilter extends Component {
  state = {
    bool: null,
  };

  handleChange = event => {
    this.setState({ bool: event.target.value }, () => this.filter());
  };

  filter = () => {
    const { bool } = this.state;
    this.props.onChange(bool);
  };

  render() {
    const { id } = this.props;
    const { bool } = this.state;
    return (
      <SingleSelect
        options={options}
        id={id}
        name="boolFilter"
        value={bool}
        onChange={this.handleChange}
      />
    );
  }
}

BoolFilter.propTypes = {
  id: string.isRequired,
  onChange: func.isRequired,
};

export default BoolFilter;
